import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "../../../axios";
import { Helmet } from "react-helmet";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";

import styles from "./Create.module.css";

import FormikControl from "../../../components/FormikControl/FormikControl";
import Button from "../../../components/Button/Button";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";

class Create extends Component {
  state = {
    isLoading: false,
    password: "",
    formId: 1,
  };

  render() {
    const initialValues = {
      title: "",
      firstName: "",
      lastName: "",
      userId: "",
      phone: "",
      email: "",
      dateOfBirth: "",
      pan: "",
      address: "",
      status: "",
    };

    const validationSchema = Yup.object({
      title: Yup.string().required("Title is required"),
      firstName: Yup.string()
        .required("First Name is required")
        .trim()
        .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field"),
      lastName: Yup.string()
        .required("Last Name is required")
        .trim()
        .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field"),
      userId: Yup.string()
        .required("User ID is required")
        .trim()
        .matches(
          /^[A-Z0-9]+$/,
          "Only Uppercase alphabets and numbers are allowed for this field"
        ),
      phone: Yup.string()
        .required("Phone is required")
        .matches(/^[0-9]+$/, "Not a Valid Phone Number"),
      email: Yup.string()
        .required("Email is required")
        .matches(/^[a-zA-Z0-9.@_ ]+$/, "Invalid Email ID")
        .test("regex", "Invalid Email ID", (val) => {
          const regExpEmail = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i);
          return regExpEmail.test(val);
        }),
      dateOfBirth: Yup.string().required("Date of Birth is required"),
      pan: Yup.string().required("PAN is required"),
      address: Yup.string().required("Address is required"),
      status: Yup.string().required("Status is required"),
    });

    const onSubmit = (values) => {
      this.setState({ isLoading: true });

      const formData = {
        title: values.title,
        first_name: values.firstName,
        last_name: values.lastName,
        user_id: values.userId,
        phone: values.phone,
        email: values.email,
        date_of_birth: moment(values.dateOfBirth).format("YYYY-MM-DD"),
        pan: values.pan,
        address: values.address,
        status: values.status,
      };

      axios
        .post("/users", formData)
        .then((response) => {
          toast.success(response.data.message);
          this.setState((prevState) => ({
            formId: prevState.formId + 1,
          }));
        })
        .catch((error) => {
          if (error.response.data.code === 2001) {
            const errors = error.response.data.errors;
            toast.error(Object.values(errors[0])[0]);
          } else {
            toast.error(error.response.data.message);
          }
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    };

    const titleOptions = [
      { value: "Mr", label: "Mr" },
      { value: "Miss", label: "Miss" },
      { value: "Mrs", label: "Mrs" },
    ];

    const statusOptions = [
      { value: "0", label: "Disabled" },
      { value: "1", label: "Enabled" },
    ];

    return (
      <div className={styles.Create}>
        <Helmet>
          <title>New | Users | Lara Capital</title>
        </Helmet>
        <div className="PageHeader">
          <div className="ContentLeft">
            <div className="Title">
              <h1>Users</h1>
            </div>
            <Breadcrumb>
              <li>
                <Link to="/">Dashboard</Link>
              </li>
              <li>
                <Link to="/users">Users</Link>
              </li>
              <li>New</li>
            </Breadcrumb>
          </div>
        </div>
        <div className="PageContent DataForm">
          <div className="ContentHeader">
            <div className="Title">
              <h1>Add User</h1>
            </div>
          </div>
          <div className="MainContent">
            <div className="FormContainer">
              <Formik
                key={this.state.formId}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {({ setFieldValue }) => {
                  return (
                    <Form>
                      <div className={["FormBody", styles.FormBody].join(" ")}>
                        <FormikControl
                          control="select"
                          label="Title *"
                          name="title"
                          options={titleOptions}
                          setFieldValue={setFieldValue}
                        />

                        <FormikControl
                          control="input"
                          type="text"
                          label="First Name *"
                          name="firstName"
                          maxLength="30"
                        />

                        <FormikControl
                          control="input"
                          type="text"
                          label="Last Name *"
                          name="lastName"
                          maxLength="30"
                        />

                        <FormikControl
                          control="input"
                          type="text"
                          label="User ID *"
                          name="userId"
                          maxLength="12"
                        />

                        <FormikControl
                          control="input"
                          type="text"
                          label="Phone *"
                          name="phone"
                          maxLength="10"
                        />

                        <FormikControl
                          control="input"
                          type="text"
                          label="Email *"
                          name="email"
                          maxLength="150"
                          autoComplete="new-password"
                        />

                        <FormikControl
                          control="input"
                          type="text"
                          label="PAN *"
                          name="pan"
                          maxLength="10"
                        />

                        <FormikControl
                          control="date"
                          type="text"
                          label="Date of Birth *"
                          name="dateOfBirth"
                          setFieldValue={setFieldValue}
                        />

                        <FormikControl
                          control="input"
                          type="text"
                          label="Address *"
                          name="address"
                          maxLength="255"
                        />

                        <FormikControl
                          control="select"
                          label="Status *"
                          name="status"
                          options={statusOptions}
                          setFieldValue={setFieldValue}
                        />
                      </div>

                      <div
                        className={["FormActions", styles.FormActions].join(
                          " "
                        )}
                      >
                        <Button
                          btnType="Primary"
                          type="Submit"
                          width="W100"
                          isLoading={this.state.isLoading}
                        >
                          Save
                        </Button>
                      </div>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        </div>
        <ToastContainer />
      </div>
    );
  }
}

export default Create;
